import styled from "styled-components";

export const PageContent = styled.div`
  padding: 0 40px;
  background-color: #1b1f24;
`;
export const Container = styled.div`
  background-color: #121418;
`;
